function toCategoryAsyncMultiValuedListMoreItem(option) {
  return {
    children: option.name,
  }
}

export function getDataItems(response) {
  return response.data.items.map(toCategoryAsyncMultiValuedListMoreItem)
}
